import { jsx } from "react/jsx-runtime";
import { useMemo, useLayoutEffect, useEffect } from "react";
import { useCookbookContext, CookbookContextProvider } from "@creditornot/cb-context";
import { DATA_ATTR_THEME, DATA_ATTR_HEADING_FONT, resolveHeadingFontByLocale } from "@creditornot/cb-utils";
import "./style.css";
const semanticCssVarsClassName = "cb_semanticCssVars_sl0l";
const useIsomorphicLayoutEffect = typeof window === "object" ? useLayoutEffect : useEffect;
const useThemeMode = () => {
  const cookbookContext = useCookbookContext();
  if (!cookbookContext) {
    throw new Error("useThemeMode must be used inside CookbookProvider.");
  }
  return cookbookContext.themeMode;
};
const useDirection = () => {
  const cookbookContext = useCookbookContext();
  if (!cookbookContext) {
    throw new Error("useDirection must be used inside CookbookProvider.");
  }
  return cookbookContext.direction;
};
const useAssertCookbookDomain = (domain) => {
  const cookbookContext = useCookbookContext();
  if (process.env.NODE_ENV === "test" && !cookbookContext) {
    return;
  }
  if (!cookbookContext) {
    throw new Error("useAssertCookbookDomain must be used inside CookbookProvider.");
  }
  const cookbookDomain = cookbookContext.domain;
  if (cookbookDomain !== domain) {
    throw new Error(`Invalid Cookbook domain: '${cookbookDomain}'.`);
  }
};
const CookbookProvider = ({
  children,
  direction,
  locale,
  themeMode
}) => {
  useIsomorphicLayoutEffect(() => {
    if (!document.documentElement.classList.contains(semanticCssVarsClassName)) {
      document.documentElement.classList.add(semanticCssVarsClassName);
    }
  }, []);
  useIsomorphicLayoutEffect(() => {
    document.documentElement.setAttribute(DATA_ATTR_THEME, themeMode);
  }, [themeMode]);
  useIsomorphicLayoutEffect(() => {
    document.documentElement.setAttribute(
      DATA_ATTR_HEADING_FONT,
      resolveHeadingFontByLocale(locale)
    );
  }, [locale]);
  useIsomorphicLayoutEffect(() => {
    document.documentElement.setAttribute("dir", direction);
  }, [direction]);
  const contextValue = useMemo(
    () => ({ direction, domain: "consumer", themeMode }),
    [direction, themeMode]
  );
  return /* @__PURE__ */ jsx(CookbookContextProvider, { value: contextValue, children });
};
export {
  CookbookProvider,
  semanticCssVarsClassName,
  useAssertCookbookDomain,
  useDirection,
  useThemeMode
};
//# sourceMappingURL=index.js.map
